import DataQuery from "data/DataQuery";
import {
  Dashboard_ExpectedPayments,
  Dashboard_LastInvoices,
} from "data/endpoints";
import { useQuery } from "data/hooks/useQuery";
import { Dashboard_InvoicesCard_LastInvoices } from "features/shared/components/loaders/promiseLoadingAreas";
import { getRouteParams } from "features/shared/helpers/routeParams";
import CustomerState from "infrastructure/store/customer/CustomerState";
import IAppState from "infrastructure/store/IAppState";
import React from "react";
import { useSelector } from "react-redux";
import InvoiceSimplifiedDTO from "features/invoices/dtos/InvoiceSimplifiedDTO";
import { getQueryParams } from "features/shared/helpers/queryParams";
import DashboardSectionProps from "features/dashboard/models/DashboardSectionProps";
import DashboardListingCard from "../components/DashboardListingCard";
import InvoiceDashboardRow from "features/invoices/components/InvoiceDashboardRow";
import { useInjection } from "infrastructure/ioc/ioc.react";
import IDashboardService from "../services/IDashboardService";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import { useTranslation } from "react-i18next";

interface Configuration {
  url: string;
  loaderArea: string;
  route?: string;
}

const EnpointTypesMap: Record<string, Configuration> = {
  lastInvoices: {
    url: Dashboard_LastInvoices,
    loaderArea: Dashboard_InvoicesCard_LastInvoices,
    route: "/invoices"
  },
  expectedPayments: {
    url: Dashboard_ExpectedPayments,
    loaderArea: Dashboard_ExpectedPayments,
    route: undefined
  },
};

const DashboardInvoicesSection = (props: DashboardSectionProps) => {
  // translations
  const t = useTranslation("dashboard\\dashboard").t;

  // DI
  const dashboardService = useInjection<IDashboardService>(
    IocTypes.DashboardService
  );

  // private props
  const itemsCount = props.itemsCount ?? 4;
  const configuration = dashboardService.getConfiguration<Configuration>(
    props.additionalInfo!,
    "type",
    EnpointTypesMap,
    "Invoices"
  );

  // STORE
  const customer = useSelector<IAppState, CustomerState>(
    (store) => store.customer
  ).customer;

  // fetch data
  const query: DataQuery = {
    url: configuration.url,
    routeParams: getRouteParams("customerId", customer.customerId!),
    params: getQueryParams("Count", itemsCount.toString()),
  };
  const { data, loadStatus } = useQuery<InvoiceSimplifiedDTO[]>(
    query,
    [],
    [customer],
    {
      useTracker: true,
      area: configuration.loaderArea,
    }
  );  

  // RENDER
  return (          
      <DashboardListingCard
        title={t(`dashboardItems.${props.title}`)}
        items={data}
        renderItem={(item) => <InvoiceDashboardRow invoice={item} />}
        itemsLoadStatus={loadStatus}
        moduleRoute={configuration.route}
        background={props.background}
        icon={props.icon}
        iconColor={props.iconColor}
        count={itemsCount}
        loaderArea={configuration.loaderArea}
      />    
  );
};

export default DashboardInvoicesSection;
